import { Select } from "@mantine/core";
import { type Priority, TodoStatus } from "../../../utils/backend-types";
import { useShouldShowStaffView } from "../../StaffViewToggle/useShouldShowStaffView";
import { PRIORITIES, TODO_DOCUMENT_STATUS } from "../Todos.constants";
import { getTodoStatusOptions } from "../utils/getTodoStatusOptions";

interface PriorityCellProps {
  priorityValue: Priority;
  id: number;
  onChangePriority: (priorityValue: Priority, id: number) => void;
}

export function PriorityCell({
  priorityValue,
  id,
  onChangePriority
}: PriorityCellProps) {
  return (
    <Select
      data={PRIORITIES}
      value={priorityValue}
      onChange={(newValue) => {
        if (newValue) {
          onChangePriority(newValue as Priority, id);
        }
      }}
    />
  );
}

export interface TodoStatusCellProps {
  status: TodoStatus;
  id: number;
  label: string;
  onChangeStatus: (status: TodoStatus, todoId: number) => void;
}

export function TodoStatusCell({
  status,
  id,
  label,
  onChangeStatus
}: TodoStatusCellProps) {
  const { shouldShowStaffView: isStaff } = useShouldShowStaffView();
  const options = getTodoStatusOptions(status, label, isStaff);
  const disabled = !isStaff && status === TodoStatus.NotRelevant;

  return (
    <Select
      data={options}
      disabled={disabled}
      value={status.toString()}
      w="100%"
      onChange={(newValue) => onChangeStatus(newValue as TodoStatus, id)}
    />
  );
}

interface TodoDocumentStatusCellProps {
  status: boolean;
  id: number;
  onChangeTodoStatus: (todoId: number) => void;
  isStaff: boolean;
}

export function TodoDocumentStatusCell({
  status,
  id,
  onChangeTodoStatus,
  isStaff
}: TodoDocumentStatusCellProps) {
  return isStaff ? (
    <Select
      data={TODO_DOCUMENT_STATUS}
      value={status.toString()}
      w="100%"
      onChange={() => onChangeTodoStatus(id)}
    />
  ) : (
    TODO_DOCUMENT_STATUS.find(
      (documentStatus) => documentStatus.value === status.toString()
    )?.label
  );
}
